import ModalSurface from "./ModalSurface";

export default function Dialog({ size = "md", surfaceClassName = "", ...props }) {
  return (
    <ModalSurface
      {...props}
      kind="dialog"
      surfaceClassName={`lz-v2-dialog--${size} ${surfaceClassName}`.trim()}
    />
  );
}
